import * as echarts from 'echarts';
import { ECBasicOption } from 'echarts/types/dist/shared';
import { useEffect, useRef } from "react";

interface IProps {
    xAxis: any
    series: any
}
const ChartStarvings: React.FC<IProps> = ({ xAxis, series }) => {
    const chartRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (chartRef.current) {
            const existInstance = echarts.getInstanceByDom(chartRef.current)
            if (existInstance) echarts.dispose(chartRef.current)
            chartRef.current.style.height = series.length > 0 ? `32px` : `8px`;
            const chart = echarts.init(chartRef.current);
            const option: ECBasicOption = {
                tooltip: {
                    trigger: 'item',
                },
                grid: {
                    top: 0,
                    right: '20px',
                    bottom: 0
                },
                xAxis: {
                    ...xAxis,
                    show: false,
                },
                yAxis: {
                    type: 'category',
                    axisLabel: { show: false },
                    axisTick: { show: false },
                    axisLine: { show: false },
                    name: '',
                },
                series
            };
            chart.setOption(option, true);
        }
    }, [series, xAxis]);

    return <div ref={chartRef} style={{ height: '8px', width: '100%' }} />
}

export default ChartStarvings;